import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import RenunciaReceitaService from '../../../../services/renunciaReceita-auth';
import Renuncia from './renuncia';


const ListarRenuncias = () => {


    const [renuncias, setRenuncias] = useState([]);
    const [editar, setEditar] = useState("");
    const [vazio, setVazio] = useState(false);
    const [renuncia, setRenuncia] = useState("");


    async function fetchRenuncias() {
        const response = await RenunciaReceitaService.listar();
        if (response.data.length >= 1) {
            setRenuncias(response.data)
            setVazio(false)
        } else {
            setRenuncias([])
            setVazio(true)
        }
    }

    const handleEditar = (id) => {
        setRenuncia(id);
        setEditar(true)
    }


    const deletar = async (id) => {
        if (window.confirm('Tem certeza que deseja deletar a Renúncia de Receita?')) {
            await RenunciaReceitaService.deletar(id)
            alert("Renúncia de Receita deletada com sucesso!")
            fetchRenuncias();
        }
    }

    useEffect(() => {
        fetchRenuncias();
    }, []);



    if (editar) {
        return (
            <Navigate to={`/restrito/renuncias/renunciareceita/editar/${renuncia}`} />
        )
    }
    else {
        return (
            <Fragment>
                <Fragment>
                    <FormBusca
                        setRenuncias={setRenuncias}
                        setVazio={setVazio}
                        fetchRenuncias={fetchRenuncias}
                    />
                </Fragment>
                {vazio ? <Fragment>
                    <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
                </Fragment> :
                    <Fragment>
                        <Row xs={1} lg={3}>
                            {renuncias.map((renuncia, index) =>
                                <Renuncia
                                    fetchRenuncias={fetchRenuncias}
                                    renuncia={renuncia}
                                    key={index}
                                    editar={handleEditar}
                                    deletar={deletar}
                                />
                            )}
                        </Row>
                    </Fragment>}
            </Fragment>

        )
    }
}

export default ListarRenuncias;